/// <amd-module name="Reporting/ReportWidgetHost/CopyWidget" />
import { WidgetCopyProps } from "Dashboards/WidgetContracts/Internal/WidgetHostProps";
import { IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";

import { Widget } from "Dashboards/Common/Contracts/Dashboard";
import { TeamContext } from "Dashboards/Common/Contracts/TeamContext";
import { getDashboardClient } from "Dashboards/Common/RestClient/Dashboard";
import { WidgetCopySucceeded } from "Reporting/ReportWidgetHost/Resources";
import { IProjectData, ITfsPageService } from "Tfs/Platform/Page";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { traceException } from "VSS/Platform/Trace";

export async function copyWidget(pageContext: IVssPageContext, widgetCopyInfo: WidgetCopyProps) {
    try {
        const widgetCopy = packWidget(widgetCopyInfo);
        const project = getProject(pageContext);
        const teamContext = {
            teamId: widgetCopyInfo.destinationDashboard.groupId || "",
            projectId: project.id
        } as TeamContext;

        const dashboardClient = getDashboardClient(pageContext);
        const response = await dashboardClient.createWidget(widgetCopy, teamContext, widgetCopyInfo.destinationDashboard.id);

        if (response != null && response.id != widgetCopy.id) {
            // If the widget was given an id by the server, the copy was successful.
            const messageService = pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
            messageService.addToast({
                duration: 3000,
                message: format(WidgetCopySucceeded, widgetCopyInfo.sourceWidget.name, widgetCopyInfo.destinationDashboard.name)
            });
        }
    } catch (e) {
        traceException(pageContext, "ReportingWidgetHost", "copyWidget()", e);
        console.log(e);
    }
}

export function packWidget(widgetCopyInfo: WidgetCopyProps): Widget {
    return {
        contributionId: widgetCopyInfo.sourceWidget.contributionId,
        name: widgetCopyInfo.sourceWidget.name,
        size: widgetCopyInfo.sourceWidget.size,
        settings: widgetCopyInfo.sourceWidget.settings!,
        settingsVersion: widgetCopyInfo.sourceWidget.settingsVersion
    } as Widget;
}

function getProject(pageContext: IVssPageContext): IProjectData {
    const tfsPageService = pageContext.getService<ITfsPageService>("ITfsPageService");
    const tfsPageData = tfsPageService.getData();
    if (!tfsPageData || !tfsPageData.project) {
        throw new Error("Couldn't fetch project information.");
    }
    return tfsPageData.project;
}
